import { useCallback, useEffect, useState } from "react";

import { getCoupons } from "services/coupons/rest";
import { CouponDto, CouponTypeDto } from "services/coupons/restModels";

export interface UseCouponsResult {
    coupons: CouponDto[];
    total: number;
    loading: boolean;
    error: boolean;
    refetch: () => void;
}

// Пагинация серверная (skip/limit, как во всех списках проекта): окно и фильтры держит
// вызывающая фича, хук тянет страницу и общее количество.
export const useCoupons = (
    menuId: number | null,
    type: CouponTypeDto | null,
    skip: number,
    limit: number
): UseCouponsResult => {
    const [coupons, setCoupons] = useState<CouponDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // Меню не выбрано — запрос без него бессмыслен. Загрузку снимаем: у филиала может
        // не быть ни одного меню, и экран должен показать пустое состояние, а не спиннер.
        if (menuId === null) {
            setCoupons([]);
            setTotal(0);
            setLoading(false);
            return undefined;
        }

        // ignore-флаг: ответ по прошлому меню, фильтру или странице не трогает стейт.
        let ignore = false;

        setLoading(true);
        setError(false);

        getCoupons(menuId, type, skip, limit)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setCoupons(result.items);
                    setTotal(result.total);
                } else {
                    setError(true);
                    setCoupons([]);
                    setTotal(0);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setCoupons([]);
                setTotal(0);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, type, skip, limit, reloadKey]);

    return { coupons, total, loading, error, refetch };
};
